import {useLocation} from 'react-router-dom';
import {useSelector} from 'react-redux';

export const useIsLandingPage = (): boolean => {
    const {pathname} = useLocation();
    return pathname === '/';
};

export const useIsSearchPage = (): boolean => {
    const isLandingPageEnabled = useSelector((state) => state.config.landingPage.enabled);
    const {pathname} = useLocation();
    return pathname.toString().startsWith('/search') || (!isLandingPageEnabled && pathname === '/');
};

export const useIsAnalysisPage = (): boolean => {
    const {pathname} = useLocation();
    return pathname === '/analysis' || pathname === '/analysis/';
};
